import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { useStore } from "../../helpers";
import { WordCloud } from "../../components/Charts";

export const PrintMediaReportQuotes = observer(() => {
    const { mediaStore } = useStore();
    const { from_date, to_date, lang, sources } = mediaStore.printMediaFilters;
    const [keywords, setKeywords] = useState([]);

    useEffect(() => {
        const refreshData = async () => {
            await mediaStore.getArticles();
            if (!mediaStore.articles?.quotes) return;
            setKeywords(toJS(mediaStore.articles["quotes"]["keywords"]));
        };
        void refreshData();
    }, [from_date, to_date, lang, sources, mediaStore]);

    return (
        <>
            <div className="mb-5 mt-10 text-2xl font-bold uppercase text-indigo-800">your statements</div>
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                <div className="flex flex-col rounded-lg bg-white p-4 font-bold text-purple-500 shadow-lg" style={{ height: 550 }}>
                    <div className="px-4 pb-4 text-2xl">Word Cloud</div>
                    <WordCloud words={keywords} />
                </div>
            </div>
        </>
    );
});
